import { useAsyncData } from '#imports'
import type { Ref } from 'vue'

import type { AlgoliaProduct } from '@backmarket/http-api/src/api-specs-search-reco/search/searchAlgolia'
import { useAlgoliaSearchOptions } from '@backmarket/nuxt-layer-algolia/useAlgoliaSearchOptions'
import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import algoliasearch from 'algoliasearch'

// Fetches a single Algolia outlet product by objectID by querying Algolia directly
export function useOutletProduct(objectId: Ref<string>) {
  const algoliaSearchOption = useAlgoliaSearchOptions('search')
  const $httpFetch = useHttpFetch()

  return useAsyncData<AlgoliaProduct | null>(
    getAsyncDataKey('outlet-product', { objectId: objectId.value }),
    async () => {
      let indexName: string | undefined
      try {
        const config = await $httpFetch('/bm/search/v2/configuration/:scope', {
          pathParams: { scope: 'search-landing' },
        })
        indexName = config.indexes.active.name
      } catch {
        return null
      }

      if (!indexName) return null

      const algoliaClient = algoliasearch('dummy_app_id', 'dummy_key', {
        ...algoliaSearchOption,
      })

      try {
        const result = await algoliaClient
          .initIndex(indexName)
          .search<AlgoliaProduct>('', {
            filters: `objectID:"${objectId.value}"`,
            hitsPerPage: 1,
          })

        return result.hits[0] ?? null
      } catch {
        return null
      }
    },
    {
      watch: [objectId],
      default: () => null,
    },
  )
}
